import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { EChartsOption } from 'echarts';
import { RapportsService, FiltreRapport } from '../rapports.service';
import { FiltresCommunsRapports } from '../rapports.component';

@Component({
  selector: 'app-rapport-finance',
  templateUrl: './rapport-finance.component.html'
})
export class RapportFinanceComponent implements OnInit, OnChanges {
  @Input() filtres!: FiltresCommunsRapports;

  chargement = { cout: true, anomalies: true, rentab: true, dashboard: true };

  cout: any = null;
  anomalies: any = null;
  rentab: any = null;
  dashboard: any = null;

  filtreTypeIncident: string | null = null;

  optCoutEvolution: EChartsOption = {};
  optCoutParType: EChartsOption = {};
  optDashboardSerie: EChartsOption = {};
  optDashboardModes: EChartsOption = {};

  constructor(private service: RapportsService) {}

  ngOnInit(): void { this.charger(); }
  ngOnChanges(): void { this.charger(); }

  private filtreApi(extra: Partial<FiltreRapport> = {}): FiltreRapport {
    return {
      debut: this.filtres.debut, fin: this.filtres.fin,
      zoneId: this.filtres.zoneId, typeEnvoi: this.filtres.typeEnvoi,
      granularite: this.filtres.granularite,
      ...extra
    };
  }

  charger(): void {
    this.chargerCout();
    this.chargerAnomalies();
    this.chargerRentab();
    this.chargerDashboard();
  }

  private chargerCout(): void {
    this.chargement.cout = true;
    this.service.coutMoyen(this.filtreApi()).subscribe({
      next: (d) => { this.cout = d; this.chargement.cout = false; },
      error: () => this.chargement.cout = false
    });
  }

  private chargerAnomalies(): void {
    this.chargement.anomalies = true;
    this.service.coutAnomalies(this.filtreApi({ typeIncident: this.filtreTypeIncident })).subscribe({
      next: (d) => {
        this.anomalies = d;
        const evMap = d.evolutionMensuelle || {};
        const keys = Object.keys(evMap);
        this.optCoutEvolution = {
          tooltip: { trigger: 'axis' },
          grid: { left: 40, right: 20, top: 30, bottom: 30 },
          xAxis: { type: 'category', data: keys, axisLabel: { color: '#64748b', fontSize: 11 } },
          yAxis: { type: 'value', splitLine: { lineStyle: { color: '#f1f5f9' } }, axisLabel: { color: '#64748b' } },
          series: [{
            name: 'Incidents', type: 'line', smooth: true,
            data: keys.map(k => evMap[k]),
            lineStyle: { color: '#dc2626', width: 2.5 },
            itemStyle: { color: '#dc2626' },
            areaStyle: { color: { type: 'linear', x: 0, y: 0, x2: 0, y2: 1, colorStops: [
              { offset: 0, color: 'rgba(220,38,38,0.25)' }, { offset: 1, color: 'rgba(220,38,38,0)' }
            ]}}
          }]
        };

        const parType = d.coutParTypeIncident || {};
        this.optCoutParType = {
          tooltip: { trigger: 'item' },
          legend: { bottom: 0, type: 'scroll' },
          series: [{
            type: 'pie', radius: ['45%', '70%'],
            itemStyle: { borderRadius: 6, borderColor: '#fff', borderWidth: 2 },
            label: { show: false }, labelLine: { show: false },
            data: Object.entries(parType).map(([name, value]) => ({ name, value: value as number }))
          }]
        };
        this.chargement.anomalies = false;
      },
      error: () => this.chargement.anomalies = false
    });
  }

  private chargerRentab(): void {
    this.chargement.rentab = true;
    this.service.rentabiliteClients(this.filtreApi()).subscribe({
      next: (d) => { this.rentab = d; this.chargement.rentab = false; },
      error: () => this.chargement.rentab = false
    });
  }

  private chargerDashboard(): void {
    this.chargement.dashboard = true;
    this.service.dashboardFinancier(this.filtreApi()).subscribe({
      next: (d) => {
        this.dashboard = d;
        const serie = d.serieTemporelle || {};
        const keys = Object.keys(serie);
        this.optDashboardSerie = {
          tooltip: { trigger: 'axis' },
          grid: { left: 50, right: 20, top: 30, bottom: 30 },
          xAxis: { type: 'category', data: keys, axisLabel: { color: '#64748b', fontSize: 11 } },
          yAxis: { type: 'value', splitLine: { lineStyle: { color: '#f1f5f9' } }, axisLabel: { color: '#64748b', formatter: (v: any) => (v / 1000).toFixed(0) + 'k' } },
          series: [{
            name: 'CA', type: 'bar',
            data: keys.map(k => serie[k]),
            itemStyle: { color: '#10b981', borderRadius: [4, 4, 0, 0] },
            barWidth: '50%'
          }]
        };

        const modes = d.encaissementsParMode || {};
        this.optDashboardModes = {
          tooltip: { trigger: 'item' },
          legend: { bottom: 0 },
          series: [{
            type: 'pie', radius: ['45%', '70%'],
            itemStyle: { borderRadius: 6, borderColor: '#fff', borderWidth: 2 },
            label: { show: false }, labelLine: { show: false },
            data: Object.entries(modes).map(([name, value]) => ({ name, value: value as number }))
          }]
        };
        this.chargement.dashboard = false;
      },
      error: () => this.chargement.dashboard = false
    });
  }
}
